

'use client';

import { Header } from '@/components/header';
import { Footer } from '@/components/footer';
import Link from 'next/link';
import type { Metadata } from 'next';

export default function PrivacyPolicyPage() {
    return (
        <div className="flex flex-col min-h-screen">
            <Header />
            <main className="flex-1 container mx-auto px-4 py-8">
                <div className="max-w-3xl mx-auto">
                    <div className="text-center mb-12">
                        <h1 className="text-4xl font-headline mb-2">Privacy Policy</h1>
                        <p className="text-xl text-muted-foreground">How we collect, use, and protect your data.</p>
                    </div>

                    <div className="prose dark:prose-invert lg:prose-lg mx-auto text-foreground/80 space-y-6">
                         <h2 className="font-headline text-3xl text-foreground">Your privacy is important to us.</h2>
                        <p>
                            At Art Vault, we are committed to protecting your privacy.
                        </p>
                        <p>
                            We don&apos;t collect your information beyond what is necessary for the basic functionality of this application (e.g., your authentication details if you sign up).
                        </p>
                        <p>
                            We won&apos;t be selling your information.
                        </p>
                        <p>
                           The artworks and related data you add to your private collection are yours and are not shared unless you explicitly mark them as public. Publicly shared artworks are visible to other users of Art Vault.
                        </p>
                         <p>
                           This policy may be updated from time to time. Please review it periodically.
                        </p>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}
